/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { FaTag } from "react-icons/fa";
import { toast } from "react-toastify";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { TipoFormulario } from "../../../../services/constantes";
import { ApiError, Campo, Cupom, TpDesconto } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { ConverterTipoDescontoParaTexto } from "../../../../services/utilitarios";

function CupomListagemm() {
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [cupoms, setCupoms] = useState<Cupom[]>([]);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [cupomSelecionado, setCupomSelecionado] = useState<Cupom>({} as Cupom);
    const [escolhaTipoDesconto, setEscolhaTipoDesconto] = useState<TpDesconto>();
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    const colunas = [
        { field: 'codigo', headerName: 'Código', flex: 1 },
        {
            field: 'ativo',
            headerName: 'Ativo',
            flex: 1,
            renderCell: (params: any) => {
               const ativo = Boolean(params.value);
               return ativo ? "Sim" : "Não"
            }
        },
        { field: 'valorFixo', headerName: 'Desconto Fixo (R$)', flex: 1 },
        { field: 'percentualDeDesconto', headerName: '% Desconto', flex: 1 },
    ];

    const campos: Campo[] = [
        { label: 'Código', nome: 'codigo', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Limite de uso', nome: 'limiteDeUso', required: false, tipo: 'number', largura: 6, coluna: 2, linha: 1, visible: true, tudoMaiusculo: true },
        {
            label: 'Tipo de Desconto', nome: 'tipoDeDesconto', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 2, visible: true, tudoMaiusculo: true, opcoes: [
                { label: ConverterTipoDescontoParaTexto(TpDesconto.Percentual), valor: TpDesconto.Percentual },
                { label: ConverterTipoDescontoParaTexto(TpDesconto.ValorFixo), valor: TpDesconto.ValorFixo }
            ], onCampoDigitar(e) {
                setEscolhaTipoDesconto(e as TpDesconto)
            },
        },
        { label: '% Desconto (1 ~ 100)', nome: 'percentualDeDesconto', required: escolhaTipoDesconto == TpDesconto.Percentual, tipo: 'percentual', largura: 6, coluna: 2, linha: 2, visible: escolhaTipoDesconto == TpDesconto.Percentual, tudoMaiusculo: true },
        { label: 'Valor Desconto', nome: 'valorFixo', required: escolhaTipoDesconto == TpDesconto.ValorFixo, tipo: 'money', largura: 6, coluna: 2, linha: 2, visible: escolhaTipoDesconto == TpDesconto.ValorFixo, tudoMaiusculo: true },
        { label: 'Expira Em', nome: 'expiraEm', required: false, tipo: 'datetime-local', largura: 6, coluna: 1, linha: 3, visible: true, tudoMaiusculo: true },
        { label: 'Ativo', nome: 'ativo', required: false, tipo: 'checkbox', largura: 6, coluna: 2, linha: 3, visible: true, tudoMaiusculo: true },
        { label: 'Apenas Para Empresas em Período de Teste', nome: 'ApenasParaPeriodoDeTestes', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 4, visible: true, tudoMaiusculo: true },
        { label: 'Uso único por Empresa', nome: 'usoUnicoPorEmpresa', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 5, visible: true, tudoMaiusculo: true },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemPermissao(token, 'cupom_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        const mensagem = error.response?.data.Mensagem != undefined ? error.response?.data.Mensagem : 'Escolha uma cor diferente de #000000';
        toast.error('Não foi possível continuar a operação Cupom: ' + mensagem);
        setIsSubmiting(false);
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = async () => {
        if (usuarioTemPermissao(token, 'cupom_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setCupomSelecionado({} as Cupom);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo cupom');
        }
    }

    const handleEditar = async (cupom: any) => {
        if (usuarioTemPermissao(token, 'cupom_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setCupomSelecionado(cupom);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um cupom');
        }
    }

    const handleExclusao = async (cupom: Cupom) => {
        if (usuarioTemPermissao(token, 'cupom_excluir')) {
            setCarregando(true);
            await api.delete(`/cupom/${cupom.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Cupom foi excluída com sucesso');
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = async (cupom: any) => {
        if (usuarioTemPermissao(token, 'cupom_visualizar')) {
            setCupomSelecionado(cupom);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    useEffect(() => {
        const fetchCupom = async () => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`/Cupom/`)
                    .then(response => {
                        setTimeout(() => {
                            setCupoms(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error);
                    });
            }
        }

        fetchCupom();
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Cupom salva com sucesso');
        setFezAlgumaAcao(true);
        setIsSubmiting(false);
    }

    const onSave = async (entidade: any) => {
        if (isSubmiting) return;
        setIsSubmiting(true);
        if (usuarioTemPermissao(token, 'cupom_novo') || usuarioTemPermissao(token, 'cupom_editar')) {
            const cupomASalvar: Cupom = {
                ApenasParaPeriodoDeTestes: Boolean(entidade['apenasParaPeriodoDeTestes']) || false,
                Ativo: Boolean(entidade['ativo']) || false, 
                UsoUnicoPorEmpresa: Boolean(entidade['usoUnicoPorEmpresa']) || false, 
                codigo: entidade['codigo'],
                TipoDeDesconto: entidade['tipoDeDesconto'],
                ExpiraEm: entidade['expiraEm'] || null,
                limiteDeUso: entidade['limiteDeUso'] || null,
                PercentualDeDesconto: entidade['percentualDeDesconto'] || null,
                ValorFixo: entidade['valorFixo'] || null,
            }

            if (modo == TipoFormulario.tpEdicao) {
                cupomASalvar['id'] = entidade['id'];
            }

            const apiAcao = modo == TipoFormulario.tpCadastro ? api.post : api.put;

            apiAcao('/cupom/', cupomASalvar, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => {
                setTimeout(() => {
                    requisicaoBemSucedida(response);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
        }
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('cupom')}
                    colunas={colunas}
                    linhas={cupoms}
                    nomeEntidade="Cupom"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaTag}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setCupomSelecionado} />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    onSave={onSave}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    isSaving={isSubmiting}
                    entidadeSelecionada={cupomSelecionado}
                    apiConfig={
                        {
                            endpoint: "cupom",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default CupomListagemm;